import React from 'react';
import * as styles from './UserListHoverCard.module.scss';
import UserRow from './UserRow';
import PopOver from '../components/deprecated/PopOver';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const USER_LIST_HOVER_CARD_USER_FRAGMENT = gql(`
  fragment HoverListHoverCard_user on User {
    id
    ...UserRow_user
  }
`);

interface UserListHoverCardProps {
  children: JSX.Element;
  users: DocumentType<typeof USER_LIST_HOVER_CARD_USER_FRAGMENT>[];
  trigger?: 'click' | 'hover';
}

const UserListHoverCard = ({
  children,
  users,
  trigger = 'hover',
}: UserListHoverCardProps) => {
  return (
    <PopOver
      display="inline-block"
      placement="bottom-start"
      popOver={
        <PopOver.Container>
          {users.map((user) => (
            <div key={user.id} className={styles.user}>
              <UserRow link user={user} />
            </div>
          ))}
        </PopOver.Container>
      }
      popOverPortal={document.body}
      trigger={trigger}
    >
      {children}
    </PopOver>
  );
};

export default UserListHoverCard;
